'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _FormTextfield = require('../FormTextfield/FormTextfield');

var _FormTextfield2 = _interopRequireDefault(_FormTextfield);

require('./Newsletter.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Newsletter = function (_Component) {
  (0, _inherits3.default)(Newsletter, _Component);

  function Newsletter(props) {
    (0, _classCallCheck3.default)(this, Newsletter);

    // Form default values.
    var _this = (0, _possibleConstructorReturn3.default)(this, (Newsletter.__proto__ || (0, _getPrototypeOf2.default)(Newsletter)).call(this, props));

    _this.civility = '';
    _this.name = '';
    _this.surname = '';
    _this.email = _this.props.email || '';
    _this.perfume = false;
    _this.fashion = false;
    _this.valid = '';

    _this.form = {};
    return _this;
  }

  (0, _createClass3.default)(Newsletter, [{
    key: 'initCivility',
    value: function initCivility(field) {
      if (field) {
        this.civility = field.value;
      }
    }
  }, {
    key: 'initEmail',
    value: function initEmail(field) {
      if (field) {
        this.email = field.inputElement.value;
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(field, value) {
      this[field] = value;
      this.activateSubmit();
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(field, event) {
      this[field] = event.target.checked && 'on';
      this.activateSubmit();
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(field, event) {
      this[field] = event.target.value;
      this.activateSubmit();
    }
  }, {
    key: 'onInit',
    value: function onInit(btn) {
      this.validate = btn;
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(event) {
      event.preventDefault();

      var formArray = [];
      formArray.push('title=' + this.civility);
      formArray.push('lastName=' + this.name);
      formArray.push('firstName=' + this.surname);
      formArray.push('email=' + this.email);
      formArray.push('beauty=' + this.perfume);
      formArray.push('couture=' + this.fashion);
      formArray.push('from=store.dior.com');
      formArray.push('storeShortName=' + this.props.countryCode);
      formArray.push('storeLanguage=' + this.props.countryCode);

      var form = formArray.join('&');

      this.props.submitCallback(form, this.confirmation);
    }
  }, {
    key: 'activateSubmit',
    value: function activateSubmit() {
      this.validate.disabled = !(this.name.length > 0 && this.surname.length > 0 && this.email.length > 0 && /[^\s@]+@[^\s@]+\.[^\s@]+/.test(this.email) && (this.perfume || this.fashion));
    }
  }, {
    key: 'render',
    value: function render() {
      var __ = this.props.__;

      this.confirmation = _react2.default.createElement(
        'div',
        { className: 'text-center' },
        _react2.default.createElement(
          'h3',
          { className: 'Newsletter__title' },
          __('Newsletter|Receive our newsletter')
        ),
        _react2.default.createElement(
          'div',
          null,
          __('Newsletter|Newsletter Confirmation')
        )
      );

      var newsletterTypeParfum = __('Newsletter|Perfume and beauty');
      var newsletterTypeFashion = __('Newsletter|Fashion and accessories');

      return _react2.default.createElement(
        'div',
        { className: 'Newsletter' },
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h3',
            { className: 'Newsletter__title' },
            __('Newsletter|Receive our newsletter')
          ),
          _react2.default.createElement(
            'form',
            { onSubmit: this.onSubmit.bind(this) },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'col-lg-6' },
                _react2.default.createElement(
                  'div',
                  { className: 'Newsletter__field' },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'newsletter-civility' },
                    __('Form|Civility')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'Newsletter__civility form__input form__input--select' },
                    _react2.default.createElement('span', { className: 'form__input--select-icon icon icon-arrow-down' }),
                    _react2.default.createElement(
                      'select',
                      {
                        name: 'newsletter-civility',
                        id: 'newsletter-civility',
                        onChange: this.handleSelectChange.bind(this, 'civility'),
                        ref: this.initCivility.bind(this)
                      },
                      _react2.default.createElement(
                        'option',
                        { value: __('Form|Mr'), 'default': true },
                        __('Form|Mr')
                      ),
                      _react2.default.createElement(
                        'option',
                        { value: __('Form|Mrs') },
                        __('Form|Mrs')
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-lg-6' },
                _react2.default.createElement(
                  'div',
                  { className: 'Newsletter__field' },
                  _react2.default.createElement(_FormTextfield2.default, {
                    fullWidth: true,
                    required: true,
                    name: 'newsletter-lastname',
                    id: 'newsletter-lastname',
                    placeholder: __('Form|Name'),
                    label: __('Form|Name'),
                    onChange: this.handleChange.bind(this, 'name')
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-lg-6' },
                _react2.default.createElement(
                  'div',
                  { className: 'Newsletter__field' },
                  _react2.default.createElement(_FormTextfield2.default, {
                    fullWidth: true,
                    required: true,
                    name: 'newsletter-firstname',
                    id: 'newsletter-firstname',
                    placeholder: __('Form|Surname'),
                    label: __('Form|Surname'),
                    onChange: this.handleChange.bind(this, 'surname')
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'col-lg-6' },
                _react2.default.createElement(
                  'div',
                  { className: 'Newsletter__field' },
                  _react2.default.createElement(_FormTextfield2.default, {
                    fullWidth: true,
                    required: true,
                    name: 'newsletter-email',
                    id: 'newsletter-email',
                    placeholder: __('Form|Email'),
                    label: __('Form|Email'),
                    value: this.props.email,
                    ref: this.initEmail.bind(this),
                    onChange: this.handleChange.bind(this, 'email')
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'fieldset',
                { className: 'Newsletter__type Newsletter__fieldset' },
                _react2.default.createElement(
                  'legend',
                  null,
                  __('Newsletter|Dior Newsletter')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'Newsletter__checkbox form__input--checkbox' },
                  _react2.default.createElement('input', {
                    name: 'newsletter-newsletter-type',
                    id: 'newsletter-type-parfum',
                    type: 'checkbox',
                    className: 'sr-only',
                    onChange: this.handleCheckboxChange.bind(this, 'perfume')
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'newsletter-type-parfum' },
                    __('Newsletter|I wish to receive the %(newsletter)s newsletter', { newsletter: newsletterTypeParfum })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'Newsletter__checkbox form__input--checkbox' },
                  _react2.default.createElement('input', {
                    name: 'newsletter-newsletter-type',
                    id: 'newsletter-type-fashion',
                    type: 'checkbox',
                    className: 'sr-only',
                    onChange: this.handleCheckboxChange.bind(this, 'fashion')
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'newsletter-type-fashion' },
                    __('Newsletter|I wish to receive the %(newsletter)s newsletter', { newsletter: newsletterTypeFashion })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'Newsletter__field' },
                _react2.default.createElement('input', {
                  type: 'submit',
                  className: 'Newsletter__submit button button--dark',
                  value: __('Form|Submit'),
                  ref: this.onInit.bind(this),
                  disabled: true
                })
              )
            )
          )
        )
      );
    }
  }]);
  return Newsletter;
}(_react.Component);

Newsletter.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  submitCallback: _propTypes2.default.func,
  email: _propTypes2.default.string,
  countryCode: _propTypes2.default.string
};

Newsletter.defaultProps = {
  submitCallback: function submitCallback() {},
  email: '',
  countryCode: 'INT'
};

exports.default = (0, _reactTranslate.withTranslator)()(Newsletter);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/Newsletter/Newsletter.js
// module id = 1170
// module chunks = 0